import { Root } from './List';
import { Item } from './ListItem';
import { ItemPrefix } from './ListItemPrefix';
import { ItemSuffix } from './ListItemSuffix';

export const List = {
  Root: Root,
  Item: Item,
  ItemPrefix: ItemPrefix,
  ItemSuffix: ItemSuffix,
};
